import { Grid } from "@mui/material";
import { Actions } from "../Modal";
import { Form, Input, Submit } from "../Form";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { createType, editTypes } from "../../features/types/typesSlice";

const properties = { id: '', nombre: '', encargado: '', especificacion: '' };

const Forms = () => {
    const { id, openModalEdit } = useSelector(state => state.modal)
    const { types } = useSelector(state => state.types);
    const dispatch = useDispatch();
    const methods = useForm({ shouldUnregister: true });
    const onSubmit = values => openModalEdit ? dispatch(editTypes({ id, values, setError: methods.setError})) : dispatch(createType({ values, setError: methods.setError }))
    const title = openModalEdit ? 'Editar' : 'Nuevo tipo de evento';
    const data = openModalEdit ? types.find(el => el.id === id) : properties;
    
    return(
        <Actions title={title}>
            <Form methods={methods} onSubmit={onSubmit}>
                <Grid container spacing={2}>
                    <Input name={'nombre'} label='Nombre' val={ data.nombre }  min={3} max={50} />
                    <Input name={'encargado'} label='Encargado' val={ data.encargado } size={6} min={3} max={50} />
                    <Input name={'especificacion'} min={2} label='Especificación' val={ data.especificacion } size={6} />
                    <Submit title={ openModalEdit ? 'Guardar cambios' : 'Registrar' } />
                </Grid>
            </Form>
        </Actions>
    )
}

export default Forms;